const SCHEMED_URL_PATTERN = /https?:\/\/\S+/gi
const BARE_DOMAIN_PATTERN =
  /(?:^|\s)[a-z][a-z0-9-]*(?:\.[a-z0-9-]+)*\.([a-z]{2,})(?:\/\S*)?(?=$|\s|[.,;:!?)])/i
const LIKELY_URL_TLDS = new Set([
  "com",
  "org",
  "net",
  "io",
  "dev",
  "co",
  "app",
  "ai",
  "gov",
  "edu",
  "us",
  "uk",
  "ca",
  "de",
  "fr",
  "jp",
  "me",
  "xyz",
  "info",
  "biz",
  "tv",
  "so",
  "sh",
])

export function hasUnschemedUrl(text: string): boolean {
  const stripped = text.replace(SCHEMED_URL_PATTERN, "")
  const match = BARE_DOMAIN_PATTERN.exec(stripped)
  if (!match) return false
  return LIKELY_URL_TLDS.has(match[1].toLowerCase())
}
